export const phoneNo = "+254725761794";
export const email = "info@kberen.com";
export const services = ["Web design", "Development", "Technology Education"];
export const locationAddress = "Moi University, Kesses.";
export const orgDescription =
  "TechRise Academy is a technology boot camp located at Moi University, Kesses. We equip learners comprehensively on frontend, backend, and mobile development. We also offer training in devops, cyber security, ethical hacking, and networking. We use the latest in-demand tech stack in all our offerings.";
